import { render, staticRenderFns } from "./alt-universal-table.vue?vue&type=template&id=8d0b6672&"
import script from "./alt-universal-table.ts?vue&type=script&lang=ts&"
export * from "./alt-universal-table.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports